import { Component} from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';
import { AuthService } from '../../services';
import { RecaptchaLoaderService } from 'ng-recaptcha';
import { NgForm } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';


@Component({
  selector: 'ct-recaptcha',
  templateUrl: './ct-recaptcha.component.html',
  styleUrls: ['./ct-recaptcha.component.css'],
  providers: [RecaptchaLoaderService]

})
export class CtRecaptchaComponent extends CtrlBaseComponent{

  public siteKey: string;
  captchaResponse: string | null = null;
  public isValid: boolean = false;
  private _isValidSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.isValid);
  public isValidChange$: Observable<boolean> = this._isValidSubject.asObservable();

  constructor() {
    super();
  }

  resolved(captchaResponse: string) {
    if (captchaResponse == null) {
      this.isValid = false;
    } else {
      this.isValid = true;
    }
    this._isValidSubject.next(this.isValid);
  }

  getIsValid(): boolean {
    return this.isValid;
  }
  getSiteKey(): string {
    return this.siteKey;
  }

  setIsValid(value: boolean) {
    this.isValid = value;
    this._isValidSubject.next(this.isValid);
  }
  setSiteKey(value: string) {
    this.siteKey = value;
  }

}
